
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:flex;
  height:100%;
  overflow:hidden;
  border-radius:0.75rem;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  box-shadow:var(--brand-shadow);
}
:host([is-clickable]:hover){
  box-shadow:var(--brand-shadow-lg);
}
:host([height-grow]) {
  display:block;
  height:100%;
}
:host([height-grow]) .card, :host([height-grow]) .card-wrapper {
  height:100%;
}
:host(:not([site='BH'])) h3 {
  margin:0px;
}
:host(:not([site='BH'])) h3 {
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}
:host(:not([site='BH'])):host([bg-color='white']) .card-wrapper {
  background-color:var(--neutral-white);
}
:host(:not([site='BH'])):host([bg-color='white']) .card-heading, :host(:not([site='BH'])):host([bg-color='white']) .card-cta {
  color:var(--primary-blue-light-2);
}
:host(:not([site='BH'])):host([bg-color='white']) .card-eyebrow {
  color:var(--neutral-gray-1);
}
:host(:not([site='BH'])):host([bg-color='white']) .card-content {
  color:var(--neutral-gray-1);
}
:host([bg-color='none']) .card-wrapper {
  background-color:var(--neutral-transparent);
}
:host([bg-color='none']) .card-wrapper {
  color:var(--neutral-white);
}
:host(:not([site='BH'])):host([bg-color='blue']) .card-wrapper {
  background-color:var(--primary-blue);
}
:host(:not([site='BH'])):host([bg-color='blue']) .card-wrapper {
  color:var(--neutral-white);
}
:host(:not([site='BH'])):host([bg-color='green']) .card-wrapper {
  background-color:var(--primary-green);
}
:host(:not([site='BH'])):host([bg-color='green']) .card-wrapper {
  color:var(--neutral-white);
}
:host([image-bleed]) .card-wrapper {
  position:relative;
}
:host([image-bleed]) .card-wrapper {
  background-color:var(--neutral-transparent);
}
:host([image-bleed]) .card-wrapper {
  color:var(--neutral-white);
}
:host([image-bleed]) .card-body-wrapper {
  z-index:20;
}
:host([image-bleed]) .card-body-wrapper {
  display:flex;
}
@media (min-width: 1024px) {
  :host([image-bleed]) .card-body-wrapper {
    min-height:336px;
  }
}
:host([image-bleed]) .card-body-wrapper > div:first-of-type {
  display:flex;
}
:host([image-bleed]) .card-body-wrapper > div:first-of-type {
  flex:1 1 0%;
}
:host([image-bleed]) .card-body-wrapper > div:first-of-type {
  flex-direction:column-reverse;
}
:host([image-bleed]) .card-image {
  position:absolute;
}
:host([image-bleed]) .card-image {
  top:0px;
  right:0px;
  bottom:0px;
  left:0px;
}
:host([image-bleed]) .card-image {
  display:flex;
}
:host([image-bleed]) .card-image {
  height:100%;
}
:host([image-bleed]) ::slotted(img) {
  height:100%;
}
:host([image-bleed]) ::slotted(img) {
  object-fit:cover;
}
:host([image-bleed]) .overlay{
    background:black;
  }
:host([image-bleed]) .overlay.op-0{
      opacity:0;
    }
:host([image-bleed]) .overlay.op-5{
      opacity:0.05;
    }
:host([image-bleed]) .overlay.op-10{
      opacity:0.1;
    }
:host([image-bleed]) .overlay.op-15{
      opacity:0.15;
    }
:host([image-bleed]) .overlay.op-20{
      opacity:0.2;
    }
:host([image-bleed]) .overlay.op-25{
      opacity:0.25;
    }
:host([image-bleed]) .overlay.op-30{
      opacity:0.3;
    }
:host([image-bleed]) .overlay.op-35{
      opacity:0.35;
    }
:host([image-bleed]) .overlay.op-40{
      opacity:0.4;
    }
:host([image-bleed]) .overlay.op-45{
      opacity:0.45;
    }
:host([image-bleed]) .overlay.op-50{
      opacity:0.5;
    }
:host([image-bleed]) .overlay.op-55{
      opacity:0.55;
    }
:host([image-bleed]) .overlay.op-60{
      opacity:0.6;
    }
:host([image-bleed]) .overlay.op-65{
      opacity:0.65;
    }
:host([image-bleed]) .overlay.op-70{
      opacity:0.7;
    }
:host([image-bleed]) .overlay.op-75{
      opacity:0.75;
    }
:host([image-bleed]) .overlay.op-80{
      opacity:0.8;
    }
:host([image-bleed]) .overlay.op-85{
      opacity:0.85;
    }
:host([image-bleed]) .overlay.op-90{
      opacity:0.9;
    }
:host([image-bleed]) .overlay.op-95{
      opacity:0.95;
    }
:host([image-bleed]) .overlay.op-100{
      opacity:1;
    }
@media (min-width: 768px) {
  :host([image-sideway]) .image-sideway--left .card {
    flex-direction:row;
  }
}
@media (min-width: 768px) {
  :host([image-sideway]) .image-sideway--right .card {
    flex-direction:row-reverse;
  }
}
@media (min-width: 768px) {
  :host([image-sideway]) .card {
    justify-content:space-between;
  }
}
:host([image-sideway]) .card-body-wrapper {
  flex:1 1 0%;
}
@media (min-width: 768px) {
  :host([image-sideway]) .card-body-wrapper {
    max-width:100%;
  }
}
@media (min-width: 768px) {
  :host([image-sideway]) .card-image ::slotted([slot='image']) {
    width:15rem;
  }
}
@media (min-width: 1024px) {
  :host([image-sideway]) .card-image ::slotted([slot='image']) {
    width:13rem;
  }
}
@media (min-width: 1280px) {
  :host([image-sideway]) .card-image ::slotted([slot='image']) {
    width:15rem;
  }
}
@media (min-width: 768px) {
  :host([image-sideway]) .card-image ::slotted([slot='image']) {
    height:100% !important;
  }
}
:host([sideways]):host([bg-color='green']) .card-wrapper, :host([sideways]):host([bg-color='blue']) .card-wrapper {
  min-height:240px;
}
:host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
  margin-top:14rem;
}
:host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
  background-color:var(--neutral-white);
}
@media (min-width: 768px) {
  :host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
    margin-left:15rem;
  }
}
@media (min-width: 768px) {
  :host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
    margin-top:0px;
  }
}
@media (min-width: 1024px) {
  :host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
    margin-left:13rem;
  }
}
@media (min-width: 1280px) {
  :host([sideways]):host([bg-color='green']) .card-body-wrapper, :host([sideways]):host([bg-color='blue']) .card-body-wrapper {
    margin-left:15rem;
  }
}
:host([sideways]):host([bg-color='green']) .card-heading, :host([sideways]):host([bg-color='green']) .card-cta, :host([sideways]):host([bg-color='blue']) .card-heading, :host([sideways]):host([bg-color='blue']) .card-cta {
  color:var(--primary-blue-light-2);
}
:host([sideways]):host([bg-color='green']) .card-eyebrow, :host([sideways]):host([bg-color='blue']) .card-eyebrow {
  color:var(--neutral-gray-1);
}
:host([sideways]):host([bg-color='green']) .card-content, :host([sideways]):host([bg-color='blue']) .card-content {
  color:var(--neutral-gray-1);
}
:host([site='GHS']):host([image-sideway]) .card-image ::slotted([slot='image']) {
  object-fit:cover;
}
:host([site='GHS']):host([image-sideway]) .card-image ::slotted([slot='image']) {
  height:14rem !important;
}
@media (min-width: 768px) {
  :host([site='GHS']):host([image-sideway]) .card-image ::slotted([slot='image']) {
    height:100% !important;
  }
}
.overlay {
  position:absolute;
  right:0px;
  left:0px;
  top:0px;
  bottom:0px;
  z-index:10;
  height:100%;
  width:100%;
  background:var(--black-vertical-gradient-light);
}
.text-white .card-heading, .text-white .card-eyebrow, .text-white .card-cta, .text-white .card-subheading {
  color:var(--neutral-white);
}
.is-hovered {
  cursor:pointer;
}
.is-hovered .card-heading {
  text-decoration-line:underline;
}
.card-wrapper {
  display:flex;
  width:100%;
  flex:1 1 0%;
  flex-direction:column;
  align-self:stretch;
  overflow:hidden;
  border-radius:0.75rem;
  background-color:var(--neutral-white);
}
.card {
  display:flex;
  height:100%;
  flex-direction:column;
}
.card-image {
  overflow:hidden;
}
.card-image ::slotted(img), .card-image ::slotted([slot='image']) {
  width:100%;
}
.card-body-wrapper {
  display:flex;
  flex-grow:1;
  flex-direction:column;
  padding:1.5rem;
}
.card-eyebrow {
  margin-bottom:0.5rem;
  font-family:var(--ff-body);
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:var(--fw-normal);
  text-transform:uppercase;
}
.card-heading {
  margin-bottom:0.5rem;
  font-family:var(--ff-display);
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
  font-weight:var(--fw-bold);
  text-decoration-line:none;
}
.card-subheading {
  margin-bottom:0.5rem;
  font-weight:var(--fw-semibold);
}
.card-content {
  flex-grow:1;
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
}
:host(:not([image-bleed])) .card-content {
  flex-grow:1;
}
.card-cta {
  padding-top:1rem;
  font-family:var(--ff-display);
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  font-weight:var(--fw-bold);
}
.card-cta--divider {
  margin-top:1.25rem;
  border-width:0px;
  border-top-width:1px;
  border-style:solid;
  border-color:var(--neutral-gray-4);
}
:host([site='BH']) {
  width:fit-content;
}
:host([site='BH']):host([variant='simple']) {
  height:auto;
}
:host([site='BH']):host([bg-color='blue']) .card-wrapper {
  background-color:var(--bh-brand-primary-default);
}
:host([site='BH']):host([bg-color='blue']) .card-wrapper {
  color:var(--neutral-white);
}
:host([site='BH']):host([bg-color='sky-blue']) {
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:host([site='BH']):host([bg-color='sky-blue']) .card-wrapper {
  border-color:var(--bh-brand-primary-lightest);
}
:host([site='BH']):host([bg-color='sky-blue']) .card-wrapper {
  background-color:var(--bh-brand-primary-lightest);
}
:host([site='BH']):host([variant='simple-link']) {
  overflow:visible;
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper {
  overflow:visible;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper {
  border-width:0px;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
  margin-bottom:-2.5rem;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
  align-items:center;
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
    margin-bottom:0px;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
    margin-right:-2.5rem;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
    align-items:flex-end;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-cta {
    padding-bottom:1rem;
  }
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image {
  border-radius:0.75rem;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image, :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-body-wrapper {
  height:250px;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image, :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-body-wrapper {
  width:325px;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image, :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-body-wrapper {
  max-width:100%;
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image, :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-body-wrapper {
    height:280px;
  }
}
@media (min-width: 1024px) {
  :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-image, :host([site='BH']):host([variant='simple-link']) .card-wrapper .card-body-wrapper {
    width:370px;
  }
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .overlay {
  display:none;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  position:absolute;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  top:0px;
  right:0px;
  bottom:0px;
  left:0px;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  margin:1.25rem;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  width:auto;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  border-radius:0.5rem;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  border-width:1px;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  border-style:solid;
}
:host([site='BH']):host([variant='simple-link']) .card-wrapper .inner-border {
  border-color:var(--bh-neutral-white);
}
:host([site='BH'][variant='simple-link']) {
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:host([site='BH']){
  width:auto;
}
:host([site='BH']) .card-wrapper {
  border-width:1px;
}
:host([site='BH']) .card-wrapper {
  border-style:solid;
}
:host([site='BH']) .card-wrapper {
  border-color:var(--bh-neutral-light);
}
:host([site='BH']) .card-eyebrow, :host([site='BH']) .card-subheading, :host([site='BH']) .card-content, :host([site='BH']) .card-heading {
  font-family:var(--bh-ff-body);
}
:host([site='BH']) .card-eyebrow, :host([site='BH']) .card-subheading, :host([site='BH']) .card-content, :host([site='BH']) .card-heading {
  font-weight:var(--fw-normal);
}
:host([site='BH']) .card-eyebrow {
  font-weight:var(--fw-bold);
}
:host([site='BH']) a.card-heading, :host([site='BH']) .card-heading {
  font-family:var(--bh-ff-display);
}
:host([site='BH']) a.card-heading, :host([site='BH']) .card-heading {
  font-size:var(--bh-fs-heading-04);
  line-height:var(--bh-lh-heading-04);
  letter-spacing:var(--bh-ls-heading-04);
}
:host([site='BH']) a.card-heading, :host([site='BH']) .card-heading {
  color:var(--bh-neutral-black);
}
:host([site='BH']) .text-white a.card-heading, :host([site='BH']) .text-white .card-heading {
  color:var(--neutral-white);
}
:host([site='BH']) .card-subheading {
  display:flex;
}
:host([site='BH']) .card-subheading {
  align-items:center;
}
:host([site='BH']) .card-subheading {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}
:host([site='BH']) .card-subheading ghs-icon {
  margin-right:0.5rem;
}
:host([site='BH']) .card-content {
  font-size:var(--bh-fs-body-02);
  line-height:var(--bh-lh-body-02);
  letter-spacing:var(--bh-ls-body-02);
}
:host([site='BH']) .card-cta {
  display:flex;
}
:host([site='BH']) .card-cta {
  flex-direction:column;
}
:host([site='BH']) .card-cta .cta-secondary {
  padding-top:1rem;
}
:host([site='BH']):host([image-bleed]) .card-body-wrapper {
  aspect-ratio:16 / 9;
}
:host([site='BH']):host([image-bleed]) .card-body-wrapper {
  height:auto;
}
:host([site='BH']):host([image-bleed]) .card-body-wrapper {
  min-height:fit-content;
}
:host([site='BH']):host([image-bleed]) .card-image {
  display:block;
}
:host([site='BH']):host([image-sideway]) .card-image {
  aspect-ratio:3 / 2;
}
:host([site='BH']):host([image-sideway]) .card-image {
  width:auto;
}
@media (min-width: 768px) {
  :host([site='BH']):host([image-sideway]) .card-image {
    aspect-ratio:1;
  }
}
@media (min-width: 768px) {
  :host([site='BH']):host([image-sideway]) .card-image {
    max-width:33.33%;
  }
}
`;